import { apiGet, apiUpdate, apiPost, apiDelete } from './apiClient';

const createPostAPI = async ({ data }) => apiPost({ url: `/post`, data });
const getPostListAPI = async () => apiGet({ url: `/post/list` });
const updatePostAPI = async ({ id, data }) => apiUpdate({ url: `/post?id=${id}`, data });

export { createPostAPI, getPostListAPI, updatePostAPI };
